export default "__VITE_ASSET__BqNQWNsx__"